import { createSlice, createAsyncThunk, type PayloadAction } from "@reduxjs/toolkit"
// Banners API moved to direct API calls
import { apiClient } from "../../base_url/config"

interface Banner {
  id: number
  status: string
  type: string
  image: string
}

interface BannersState {
  banners: Banner[]
  isLoading: boolean
  error: string | null
}

const initialState: BannersState = {
  banners: [],
  isLoading: false,
  error: null,
}

// Async thunk for fetching banners
export const fetchBanners = createAsyncThunk(
  "banners/fetchBanners",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiClient.get("/qr/banners")
      
      if (response.data?.data?.banners?.collection) {
        // Filter only published banners
        const publishedBanners = response.data.data.banners.collection.filter(
          (banner: Banner) => banner.status === 'published'
        )
        return publishedBanners
      } else {
        return []
      }
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to fetch banners')
    }
  }
)

const bannersSlice = createSlice({
  name: "banners",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBanners.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(fetchBanners.fulfilled, (state, action) => {
        state.isLoading = false
        state.banners = action.payload
        state.error = null
      })
      .addCase(fetchBanners.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.payload as string
        state.banners = []
      })
  },
})

export const { clearError } = bannersSlice.actions
export default bannersSlice.reducer
